import React from "react";

export default function SubNavigatinIcon(props) {
  return (
    <svg {...props} className="MuiSvgIcon-root jss66" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabindex="-1" title="AccountTree">
      <path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"></path>
    </svg>
  );
}
